export { default as XOutlineIcon } from './XOutlineIcon';
